import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  isBrowser!: boolean;

  constructor(
    private http: HttpClient,
    private storage: StorageService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  getMetadata(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get(
        `${environment.url}/main-website-general/metadata/dataFromIP`
      );
    } else {
      // Handle server-side logic or return an empty observable
      return of(null);
    }
  }

  termsOfUse(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get(
        `${environment.url}/main-website-general/TermsOfUse`
      );
    } else {
      // Handle server-side logic or return an empty observable
      return of(null);
    }
  }
  TermsOfService(): Observable<any> {
    if (isPlatformBrowser(this.platformId)) {
      return this.http.get(
        `${environment.url}/main-website-general/TermsOfService`
      );
    } else {
      // Handle server-side logic or return an empty observable
      return of(null);
    }
  }
}
